<div class='container'>
    <mat-card>
  
        <mat-toolbar mat-dialog-title fxLayoutAlign="space-between">
            <h2 style='margin-top:3px;'>
              Redefinir Senha
            </h2>
          </mat-toolbar>
  
      <div class="content">
  
        <p class="text">Informe seu e-mail para enviarmos instruções.</p>
  
        <form class="form" name="userFormForgot" [formGroup]='userFormForgot' autocomplete="off">
  
          <mat-form-field class="full-width">
            <input matInput type="email" [errorStateMatcher]="matcher" [formControl]="userFormForgot.controls.email"
              placeholder="Email" autocomplete="off">
            <mat-error
              *ngIf="userFormForgot.controls.email.hasError('email') && !userFormForgot.controls.email.hasError('required')">
              Email inválido
            </mat-error>
            <mat-error *ngIf="userFormForgot.controls.email.hasError('required')">
              Email é obrigatório
            </mat-error>
          </mat-form-field>
  
          <div class="redirectToLogin">
            <a href="#" routerLink="/sign-in">Voltar ao Login</a>          
          </div>
        </form>
      </div>
  
      <mat-dialog-actions fxLayoutAlign="flex-end" flex justify-content='flex-end'>
  
        <button mat-raised-button [disabled]="userFormForgot.invalid"
          (click)="authService.ForgotPassword(userFormForgot.controls.email.value)">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
  
      </mat-dialog-actions>
  
    </mat-card>
  </div>